<section class="main-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item" *ngIf="user.role === 'ACCOUNT_OWNER'"><a routerLink="/admin/dashboard/">Home</a></li>
      <li class="breadcrumb-item active" aria-current="page">Channels</li>
    </ol>
  </nav>
  <!-- Empty List -->
  <!-- <div class="row">
     <div class="col">
       <div class="inner-box no-listbox connect-bg pb-0">
         <div class="row mt-100">
           <div class="col-12 text-center">
             <h2 class="fw-500">Be the one to start</h2>
             <h1 class="f-46 text-orange fw-500">Connect Your Sales Channel</h1>
             <button class="btn btn-orange-prime mt-4">Create now</button>
           </div>
         </div>
       </div>
     </div>
   </div> -->
  <!-- End Empty List -->
  <div class="row">
    <div class="col">
      <div class="inner-box connect-bg2 pb-4">
        <div class="row">
          <div class="col-md-3">
            <h1 class="f-32 text-orange fw-500">Connect Your Sales Channel</h1>
            <button class="btn btn-orange-prime mt-4" routerLink="/admin/storeConnections/">Create now</button>
          </div>
        </div>
      </div>
    </div>
  </div>


  <div class="row mt-4" [hidden]="storeManagement?.storeCount == 0">
    <div class="col">
      <div class="inner-box d-none d-sm-block">
        <h2 class="color-3 text-capitalize mt-3 mb-4">My Connections</h2>
        <ul class="list-inline tab-list">
          <li class="list-inline-item"><a (click)="populateTabData('active');getStoreList('ACTIVE');  tabChange();"
                                          [ngClass]="{'active': tabClicked === 'active'}">Active</a></li>
          <li class="list-inline-item"><a (click)="populateTabData('inactive');getStoreList('IN_ACTIVE'); tabChange();"
                                          [ngClass]="{'active': tabClicked === 'inactive'}">Inactive</a></li>
        </ul>
        <div class="table-3">
          <table class="table tablesaw  tablesaw-stack" data-tablesaw-mode="stack">
            <thead class="thead-light">
            <tr>
              <th></th>
              <th>Channel Name</th>
              <th>Host Name</th>
              <!--                    <th [hidden]="tabClicked === 'inactive'">Connection</th>-->
              <th>Last Sync Time</th>
              <th>Status</th>
              <th [hidden]="tabClicked === 'inactive'" width="200">Action</th>
              <th [hidden]="tabClicked === 'active'">Action</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let s of storeManagement;let i = index;">
              <td><img width="18" height="18" src="assets/images/I_{{s.storeType}}.png"></td>
              <td>{{s.connectionName}}</td>
              <td>{{s.hostName}}</td>
              <!--                    <td [hidden]="tabClicked === 'inactive'"><button type="submit" (click)="testConnection(s)" class="btn btn-cancel">Test Connection</button></td>-->
              <td>{{s.orderUpdatedDate || 'Never Synced'}} </td>
              <td>
                <a [hidden]="s.storeType !=='MAGENTO'" *ngIf="showConnectBtn('MAGENTO')">
                  <div class="d-inline custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input float-right" [(ngModel)]="s.enableMagento"
                           (change)="updateStatus(s.connectionName,s.enableMagento,s.id,i)" id="statusMagento-{{i}}">
                    <label class="custom-control-label" for="statusMagento-{{i}}"> </label>
                  </div>
                </a>
                <a [hidden]="s.storeType !=='AMAZON'" *ngIf="showConnectBtn('AMAZON')">
                  <div class="d-inline custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input float-right" [(ngModel)]="s.enableAmazon"
                           (change)="updateStatus(s.connectionName,s.enableAmazon,s.id,i)" id="statusAmazon-{{i}}">
                    <label class="custom-control-label" for="statusAmazon-{{i}}"> </label>
                  </div>
                </a>
                <a [hidden]="s.storeType !=='SHOPCLUES'" *ngIf="showConnectBtn('SHOPCLUES')">
                  <div class="d-inline custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input float-right" [(ngModel)]="s.enableShopclues"
                           (change)="updateStatus(s.connectionName,s.enableShopclues,s.id,i)"
                           id="statusShopclues-{{i}}">
                    <label class="custom-control-label" for="statusShopclues-{{i}}"> </label>
                  </div>
                </a>
                <a [hidden]="s.storeType !=='FLIPKART'" *ngIf="showConnectBtn('FLIPKART')">
                  <div class="d-inline custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input float-right" [(ngModel)]="s.enableFlipkart"
                           (change)="updateStatus(s.connectionName,s.enableFlipkart,s.id,i)" id="statusFlipkart-{{i}}">
                    <label class="custom-control-label" for="statusFlipkart-{{i}}"> </label>
                  </div>
                </a>
                <a [hidden]="s.storeType !=='SHOPIFY'" *ngIf="showConnectBtn('SHOPIFY')">
                  <div class="d-inline custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input float-right" [(ngModel)]="s.enableShopify"
                           (change)="updateStatus(s.connectionName,s.enableShopify,s.id,i)" id="statusShopify-{{i}}">
                    <label class="custom-control-label" for="statusShopify-{{i}}"> </label>
                  </div>
                </a>
                <a [hidden]="s.storeType !=='EBAY'" *ngIf="showConnectBtn('EBAY')">
                  <div class="d-inline custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input float-right" [(ngModel)]="s.enableEbay"
                           (change)="updateStatus(s.connectionName,s.enableEbay,s.id,i)" id="statusEbay-{{i}}">
                    <label class="custom-control-label" for="statusEbay-{{i}}"> </label>
                  </div>
                </a>
                <a [hidden]="s.storeType !=='WOOCOMMERCE'" *ngIf="showConnectBtn('WOOCOMMERCE')">
                  <div class="d-inline custom-control custom-switch" *ngIf="showConnectBtn('WOOCOMMERCE')">
                    <input type="checkbox" class="custom-control-input float-right" [(ngModel)]="s.enableWoocommerce"
                           (change)="updateStatus(s.connectionName,s.enableWoocommerce,s.id,i)"
                           id="statusWoocommerce-{{i}}">
                    <label class="custom-control-label" for="statusWoocommerce-{{i}}"> </label>
                  </div>
                </a>
                <a [hidden]="s.storeType !=='BIGCOMMERCE'" *ngIf="showConnectBtn('BIGCOMMERCE')">
                  <div class="d-inline custom-control custom-switch" *ngIf="showConnectBtn('BIGCOMMERCE')">
                    <input type="checkbox" class="custom-control-input float-right" [(ngModel)]="s.enableBigcommerce"
                           (change)="updateStatus(s.connectionName,s.enableBigcommerce,s.id,i)"
                           id="statusBigcommerce-{{i}}">
                    <label class="custom-control-label" for="statusBigcommerce-{{i}}"> </label>
                  </div>
                </a>
                <a [hidden]="s.storeType !=='SNAPDEAL'" *ngIf="showConnectBtn('SNAPDEAL')">
                  <div class="d-inline custom-control custom-switch" *ngIf="showConnectBtn('SNAPDEAL')">
                    <input type="checkbox" class="custom-control-input float-right" [(ngModel)]="s.enableSnapdeal"
                           (change)="updateStatus(s.connectionName,s.enableSnapdeal,s.id,i)" id="statusSnapdeal-{{i}}">
                    <label class="custom-control-label" for="statusSnapdeal-{{i}}"> </label>
                  </div>
                </a>
                <a [hidden]="s.storeType !=='OPENCART'" *ngIf="showConnectBtn('OPENCART')">
                  <div class="d-inline custom-control custom-switch" *ngIf="showConnectBtn('OPENCART')">
                    <input type="checkbox" class="custom-control-input float-right" [(ngModel)]="s.enableOpencart"
                           (change)="updateStatus(s.connectionName,s.enableOpencart,s.id,i)" id="statusOpencart-{{i}}">
                    <label class="custom-control-label" for="statusOpencart-{{i}}"> </label>
                  </div>
                </a>
                <a [hidden]="s.storeType !=='ZOHO_COMMERCE'" *ngIf="showConnectBtn('ZOHO_COMMERCE')">
                  <div class="d-inline custom-control custom-switch" *ngIf="showConnectBtn('ZOHO_COMMERCE')">
                    <input type="checkbox" class="custom-control-input float-right" [(ngModel)]="s.enableZohoCommerce"
                           (change)="updateStatus(s.connectionName,s.enableZohoCommerce,s.id,i)"
                           id="statusZohoCommerce-{{i}}">
                    <label class="custom-control-label" for="statusZohoCommerce-{{i}}"> </label>
                  </div>
                </a>
                <a [hidden]="s.storeType !=='PRESTASHOP'" *ngIf="showConnectBtn('PRESTASHOP')">
                  <div class="d-inline custom-control custom-switch" *ngIf="showConnectBtn('PRESTASHOP')">
                    <input type="checkbox" class="custom-control-input float-right" [(ngModel)]="s.enablePrestaShop"
                           (change)="updateStatus(s.connectionName,s.enablePrestaShop,s.id,i)"
                           id="statusPrestashop-{{i}}">
                    <label class="custom-control-label" for="statusPrestashop-{{i}}"> </label>
                  </div>
                </a>
                <a [hidden]="s.storeType !=='STORE_HIPPO'" *ngIf="showConnectBtn('STORE_HIPPO')">
                  <div class="d-inline custom-control custom-switch" *ngIf="showConnectBtn('STORE_HIPPO')">
                    <input type="checkbox" class="custom-control-input float-right" [(ngModel)]="s.enableStoreHippo"
                           (change)="updateStatus(s.connectionName,s.enableStoreHippo,s.id,i)"
                           id="statusStoreHippo-{{i}}">
                    <label class="custom-control-label" for="statusStoreHippo-{{i}}"> </label>
                  </div>
                </a>
                <a [hidden]="s.storeType !=='GOOGLESHEET'" *ngIf="showConnectBtn('GOOGLESHEET')">
                  <div class="d-inline custom-control custom-switch" *ngIf="showConnectBtn('GOOGLESHEET')">
                    <input type="checkbox" class="custom-control-input float-right" [(ngModel)]="s.enableGoogleSheet"
                           (change)="updateStatus(s.connectionName,s.enableGoogleSheet,s.id,i)"
                           id="statusGoogleSheet-{{i}}">
                    <label class="custom-control-label" for="statusGoogleSheet-{{i}}"> </label>
                  </div>
                </a>

              </td>
              <td [hidden]="tabClicked === 'inactive'">
                <button type="submit" (click)="testConnection(s)" class="btn btn-blue">Test</button>
                <button *ngIf="showConnectBtn(s.storeType)" [disabled]="s.status == 'IN_ACTIVE'"
                        class="btn btn-green2 ml-3" (click)="getStoremanagement(s,s.storeType)">Manage
                </button>
              </td>
              <td [hidden]="tabClicked === 'active'"><a data-toggle="modal" data-target="#deleteApiPop"
                                                        (click)="removeStore(i)"
                                                        class="p-2 ml-3">
                <svg xmlns="http://www.w3.org/2000/svg" height="21" viewBox="0 0 18.877 24.27">
                  <defs>
                    <style>.a {
                      fill: #848484;
                    }</style>
                  </defs>
                  <path class="a"
                        d="M8.848,26.073a2.7,2.7,0,0,0,2.7,2.7H22.332a2.7,2.7,0,0,0,2.7-2.7V9.893H8.848Zm3.317-9.6,1.9-1.9,2.872,2.858L19.8,14.572l1.9,1.9L18.84,19.332,21.7,22.19l-1.9,1.9-2.858-2.858L14.08,24.091l-1.9-1.9,2.858-2.858ZM21.658,5.848,20.309,4.5H13.568L12.219,5.848H7.5v2.7H26.377v-2.7Z"
                        transform="translate(-7.5 -4.5)"/>
                </svg>
              </a></td>
            </tr>

            </tbody>
            <tfoot>
            <tr *ngIf="!storeManagement?.length || storeManagement?.length===0">
              <td colspan="6" align="center">No channel data available</td>
            </tr>
            </tfoot>
          </table>
        </div>
      </div>
      <div class="inner-box d-block d-sm-none">
        <h2 class="color-3 text-capitalize mt-3 mb-4">My Connections</h2>
        <ul class="list-inline tab-list">
          <li class="list-inline-item"><a (click)="populateTabData('active');getStoreList('ACTIVE');  tabChange();"
                                          [ngClass]="{'active': tabClicked === 'active'}">Active</a></li>
          <li class="list-inline-item"><a (click)="populateTabData('inactive');getStoreList('IN_ACTIVE'); tabChange();"
                                          [ngClass]="{'active': tabClicked === 'inactive'}">Inactive</a></li>
        </ul>
        <div class="table-3">
          <table class="table tablesaw  tablesaw-stack" data-tablesaw-mode="stack">
            <thead class="thead-light">
            <tr>
              <th></th>
              <th>Channel Name</th>
              <th>Host Name</th>
              <!--                    <th [hidden]="tabClicked === 'inactive'">Connection</th>-->
              <th>Last Sync Time</th>
              <th>Status</th>
              <th [hidden]="tabClicked === 'inactive'" width="200">Action</th>
              <th [hidden]="tabClicked === 'active'">Action</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let s of storeManagement;let i = index;">
              <td><img src="assets/images/I_{{s.storeType}}.png"></td>
              <td><b class=" tablesaw-cell-label">Channel Name</b>
                <span class="tablesaw-cell-content">{{s.connectionName}}</span></td>
              <td><b class=" tablesaw-cell-label">Host Number</b>
                <span class="tablesaw-cell-content">{{s.hostName}}</span></td>
              <!--                    <td [hidden]="tabClicked === 'inactive'"><button type="submit" (click)="testConnection(s)" class="btn btn-cancel">Test Connection</button></td>-->
              <td><b class=" tablesaw-cell-label">Last Sync Time</b>
                <span class="tablesaw-cell-content">{{s.orderUpdatedDate || 'Never Synced'}} </span></td>
              <td>
                <b class=" tablesaw-cell-label">Status</b>
                <span class="tablesaw-cell-content">
                        <a [hidden]="s.storeType !=='MAGENTO'" *ngIf="showConnectBtn('MAGENTO')">
                          <div class="d-inline custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input float-right"
                                   [(ngModel)]="s.enableMagento"
                                   (change)="updateStatus(s.connectionName,s.enableMagento,s.id,i)"
                                   id="statusMagento-{{i}}">
                            <label class="custom-control-label" for="statusMagento-{{i}}"> </label>
                          </div>
                        </a>
                        <a [hidden]="s.storeType !=='AMAZON'" *ngIf="showConnectBtn('AMAZON')">
                          <div class="d-inline custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input float-right" [(ngModel)]="s.enableAmazon"
                                   (change)="updateStatus(s.connectionName,s.enableAmazon,s.id,i)"
                                   id="statusAmazon-{{i}}">
                            <label class="custom-control-label" for="statusAmazon-{{i}}"> </label>
                          </div>
                        </a>
                        <a [hidden]="s.storeType !=='SHOPCLUES'" *ngIf="showConnectBtn('SHOPCLUES')">
                          <div class="d-inline custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input float-right"
                                   [(ngModel)]="s.enableShopclues"
                                   (change)="updateStatus(s.connectionName,s.enableShopclues,s.id,i)"
                                   id="statusShopclues-{{i}}">
                            <label class="custom-control-label" for="statusShopclues-{{i}}"> </label>
                          </div>
                        </a>
                        <a [hidden]="s.storeType !=='FLIPKART'" *ngIf="showConnectBtn('FLIPKART')">
                          <div class="d-inline custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input float-right"
                                   [(ngModel)]="s.enableFlipkart"
                                   (change)="updateStatus(s.connectionName,s.enableFlipkart,s.id,i)"
                                   id="statusFlipkart-{{i}}">
                            <label class="custom-control-label" for="statusFlipkart-{{i}}"> </label>
                          </div>
                        </a>
                        <a [hidden]="s.storeType !=='SHOPIFY'" *ngIf="showConnectBtn('SHOPIFY')">
                          <div class="d-inline custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input float-right"
                                   [(ngModel)]="s.enableShopify"
                                   (change)="updateStatus(s.connectionName,s.enableShopify,s.id,i)"
                                   id="statusShopify-{{i}}">
                            <label class="custom-control-label" for="statusShopify-{{i}}"> </label>
                          </div>
                        </a>
                        <a [hidden]="s.storeType !=='EBAY'" *ngIf="showConnectBtn('EBAY')">
                          <div class="d-inline custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input float-right" [(ngModel)]="s.enableEbay"
                                   (change)="updateStatus(s.connectionName,s.enableEbay,s.id,i)" id="statusEbay-{{i}}">
                            <label class="custom-control-label" for="statusEbay-{{i}}"> </label>
                          </div>
                        </a>
                        <a [hidden]="s.storeType !=='WOOCOMMERCE'" *ngIf="showConnectBtn('WOOCOMMERCE')">
                          <div class="d-inline custom-control custom-switch" *ngIf="showConnectBtn('WOOCOMMERCE')">
                            <input type="checkbox" class="custom-control-input float-right"
                                   [(ngModel)]="s.enableWoocommerce"
                                   (change)="updateStatus(s.connectionName,s.enableWoocommerce,s.id,i)"
                                   id="statusWoocommerce-{{i}}">
                            <label class="custom-control-label" for="statusWoocommerce-{{i}}"> </label>
                          </div>
                        </a>
                          <a [hidden]="s.storeType !=='PRESTASHOP'" *ngIf="showConnectBtn('PRESTASHOP')">
                          <div class="d-inline custom-control custom-switch" *ngIf="showConnectBtn('PRESTASHOP')">
                            <input type="checkbox" class="custom-control-input float-right"
                                   [(ngModel)]="s.enablePrestaShop"
                                   (change)="updateStatus(s.connectionName,s.enablePrestaShop,s.id,i)"
                                   id="statusPristaShop-{{i}}">
                            <label class="custom-control-label" for="statusPristaShop-{{i}}"> </label>
                          </div>
                        </a>

                          <a [hidden]="s.storeType !=='STORE_HIPPO'" *ngIf="showConnectBtn('STORE_HIPPO')">
                          <div class="d-inline custom-control custom-switch" *ngIf="showConnectBtn('STORE_HIPPO')">
                            <input type="checkbox" class="custom-control-input float-right"
                                   [(ngModel)]="s.enableStoreHippo"
                                   (change)="updateStatus(s.connectionName,s.enableStoreHippo,s.id,i)"
                                   id="statusStoreHippo2-{{i}}">
                            <label class="custom-control-label" for="statusStoreHippo2-{{i}}"> </label>
                          </div>
                        </a>
                          </span>
              </td>
              <td [hidden]="tabClicked === 'inactive'">
                <b class=" tablesaw-cell-label">Actions</b>
                <span class="tablesaw-cell-content">
                        <button type="submit" (click)="testConnection(s)" class="btn btn-blue">Test</button>
                        <button *ngIf="showConnectBtn(s.storeType)" [disabled]="s.status == 'IN_ACTIVE'"
                                class="btn btn-green2 ml-3" (click)="getStoremanagement(s,s.storeType)">Manage</button>
                        </span></td>
              <td [hidden]="tabClicked === 'active'"><a data-toggle="modal" data-target="#deleteApiPop"
                                                        (click)="removeStore(i)"
                                                        class="p-2 ml-3">
                <svg xmlns="http://www.w3.org/2000/svg" height="21" viewBox="0 0 18.877 24.27">
                  <defs>
                    <style>.a {
                      fill: #848484;
                    }</style>
                  </defs>
                  <path class="a"
                        d="M8.848,26.073a2.7,2.7,0,0,0,2.7,2.7H22.332a2.7,2.7,0,0,0,2.7-2.7V9.893H8.848Zm3.317-9.6,1.9-1.9,2.872,2.858L19.8,14.572l1.9,1.9L18.84,19.332,21.7,22.19l-1.9,1.9-2.858-2.858L14.08,24.091l-1.9-1.9,2.858-2.858ZM21.658,5.848,20.309,4.5H13.568L12.219,5.848H7.5v2.7H26.377v-2.7Z"
                        transform="translate(-7.5 -4.5)"/>
                </svg>
              </a></td>
            </tr>

            </tbody>
            <tfoot>
            <tr *ngIf="!storeManagement?.length || storeManagement?.length===0">
              <td colspan="6" align="center">No channel data available</td>
            </tr>
            </tfoot>
          </table>
        </div>
      </div>

    </div>
  </div>
</section>

<div class="container">
  <div class="modal fade" id="deleteApiPop" role="dialog">
    <div class="modal-dialog">
      &lt;!&ndash; Modal content&ndash;&gt;
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Delete</h4>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          <p>Do you really want to delete </p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-delete" data-dismiss="modal" (click)="closePopup()">No</button>
          <button type="button" class="btn btn-edit" data-dismiss="modal"
                  (click)="modifyStatus(storeManagement[index].connectionName,storeManagement[index].id,index)">Yes
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
